// extracted by mini-css-extract-plugin
export default {"zoomModal":"e3-z","image":"f3-z","button":"g3-z","isOverlayShown":"h3-z"};